import React, { useContext, useState, useRef, useMemo } from 'react';
import { DatabaseContext } from '../../../redux/DatabaseStore';
import { useFormik } from 'formik';
import { getRequest, postRequest } from '../../../api/ApiController';
import { SaveIcon, AddIcon, CopyIcon, PrintIcon, VerticalLineIcon, BackToFirstIcon, BackIcon, ForwardIcon, ForwardToLastIcon, FavoriteIcon, PriceIcon, SaveAndCloseIcon} from "../../svg/svgIcons";
import AuthContext from '../../../components/AuthContext';
import UtilContext from '../../../components/UtilContext';
import { createAsyncNavigateHandlers } from '../../../utils/asyncArrayNavigate';
import { uiT as t } from '../../../utils/uiTranslate';

export default function TrainingCompanyAdd({training_company, type}) {

    const [state,dispatch] = useContext(DatabaseContext);
    const {user} = useContext(AuthContext);
    const {toast,openFavoriteDialog,setFastView,setDialogText,setVisible} = useContext(UtilContext);
    const [closeTab,setCloseTab] = useState(false);
    const submitRef = useRef(null);

    const [formTrainingCompany,setformTrainingCompany] = useState(training_company);
    const [formType, setFormType] = useState(type);

    //TODO dorobit contractor id
    const [insertCopyIcon,setInsertCopyIcon] = useState((user.permissions?.includes("add training-company"))?false:true);
    const [scrollIcons,setScrollIcons] = useState((user.permissions?.includes("edit training-company"))?false:true);


    function addNewTrainingCompany(){
        dispatch({type:'create_new_tab',name: t('TrainingCompanyList.Tab.New'), translationKey: 'TrainingCompanyList.Tab.New', legacyLabel: t('TrainingCompanyList.Tab.New'),page:'TrainingCompanyAdd',props:{training_company: null,type:'add'},mask:'trng002'})
      }
      function copyTrainingCompany(){
        dispatch({type:'create_new_tab',name: t('TrainingCompanyList.Tab.New'), translationKey: 'TrainingCompanyList.Tab.New', legacyLabel: t('TrainingCompanyList.Tab.New'),page:'TrainingCompanyAdd',props:{training_company: formik.values,type:'add'},mask:'trng002'})
      }

    const validate = values => {
        const errors = {};
        /*if (!values.type) {
            errors.type = '*Povinné';
        }*/
        return errors;
    };

    const formik = useFormik({
        initialValues: formTrainingCompany==null?{
            name: '',address: '',tel_number:'',fax:'',email:'',web_address:'',contact_person:'',description:'',}
            :formTrainingCompany,
        enableReinitialize:true,
        validate,
        onSubmit: values => {
            const formData = new FormData();
            for (const value in values) {
                formData.append(value, values[value] != null ? values[value] : "");
            }
            if (formType === "add") {
                if (!formData.has('types') || !formData.get('types')) {
                    formData.set('types', 'training_company');
                }
                postRequest('/api/companies', formData, true)
                  .then((response) => {
                    getRequest("/api/companies").then((r) => {
                      dispatch({ type: 'load_companies', newCompanies: r.data ?? [] });
                      if (closeTab) dispatch({ type: 'close_tab', id: state.selectedTab });
                      if (response?.data?.id != null) formik.setValues({ ...formik.values, id: response.data.id });
                      setFormType("edit");
                      toast?.current?.show({ severity: 'info', summary: t('Common.Confirmed'), life: 3000, detail: t('Common.Toast.RecordSavedDetail') });
                    });
                  })
                  .catch((reason) => {
                    if (!navigator.onLine) alert(t('Common.OfflineQueued'));
                    else alert(t('Common.Toast.ActionFailedDetail'));
                  });
            } else {
                if (!formData.has('types') && values.types != null) {
                  formData.append('types', Array.isArray(values.types) ? values.types.join(',') : values.types);
                }
                postRequest(`/api/companies/update/${formik.values.id}`, formData, true)
                  .then(() => {
                    getRequest("/api/companies").then((r) => {
                      dispatch({ type: 'load_companies', newCompanies: r.data ?? [] });
                      if (closeTab) dispatch({ type: 'close_tab', id: state.selectedTab });
                      formik.setValues(values);
                      toast?.current?.show({ severity: 'info', summary: t('Common.Confirmed'), life: 3000, detail: t('Common.Toast.RecordUpdatedDetail') });
                    });
                  })
                  .catch((reason) => {
                    if (!navigator.onLine) alert(t('Common.OfflineQueued'));
                    else alert(t('Common.Toast.ActionFailedDetail'));
                  });
            }
        },
    });

    const { scrollToFirst, scrollUp, scrollDown, scrollToLast } = useMemo(() => {
        const toParams = () => {
            const p = new URLSearchParams();
            p.set('type', 'training');
            p.set('include_excluded', '1');
            return p.toString();
        };
        const buildFetchRecord = (paramsFn) => async (direction, currentId) => {
            setDialogText?.(t('Common.LoadingShort'));
            setVisible?.(true);
            try {
                const q = paramsFn();
                const url = `/api/companies/prev_next?direction=${direction}${currentId ? '&id=' + currentId : ''}&${q}`;
                const resp = await getRequest(url);
                const data = resp?.data ?? resp;
                if (direction === 'first' || direction === 'last') return data?.current ?? null;
                if (direction === 'prev') return data?.prev ?? null;
                if (direction === 'next') return data?.next ?? null;
                return null;
            } finally {
                setVisible?.(false);
            }
        };
        return createAsyncNavigateHandlers(buildFetchRecord(toParams), setformTrainingCompany, () => formTrainingCompany?.id ?? formik.values?.id);
    }, [formTrainingCompany?.id, formik.values?.id, setDialogText, setVisible]);

    return ( 
        <>
            <div>
            <div className='w-full h-10 flex flex-row bg-[#333]'>
            <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center '><button className="disabled:opacity-25" disabled={insertCopyIcon} type='submit' onClick={() => {setCloseTab(true);submitRef.current.click();}}><SaveAndCloseIcon/></button></div>
            <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center '><button className="disabled:opacity-25" disabled={insertCopyIcon} type='submit' onClick={() => {submitRef.current.click();}}><SaveIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center '><button className="disabled:opacity-25" disabled={insertCopyIcon} onClick={() => addNewTrainingCompany()}><AddIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center '><button className="disabled:opacity-25" disabled={insertCopyIcon} onClick={() => copyTrainingCompany()}><CopyIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center '><VerticalLineIcon/></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center '><button className="disabled:opacity-25" onClick={() => scrollToFirst()} disabled={scrollIcons} title={t('TrainingCompanyCardDetail.Text.Prvy_zaznam')}><BackToFirstIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center '><button className="disabled:opacity-25" onClick={() => scrollUp()} disabled={scrollIcons}><BackIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center '><button className="disabled:opacity-25" onClick={() => scrollDown()} disabled={scrollIcons}><ForwardIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center '><button className="disabled:opacity-25" onClick={() => scrollToLast()} disabled={scrollIcons}><ForwardToLastIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center '><VerticalLineIcon/></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center '><button className="disabled:opacity-25" onClick={() => openFavoriteDialog(t('Common.NewTrainingCompany'),"TrainingCompanyAdd")}><FavoriteIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center '><button onClick={() => setFastView("TrainingCompanyAdd")}><PriceIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center '><VerticalLineIcon/></div>
        </div>
        <form onSubmit={formik.handleSubmit}>
        <div className="relative flex flex-col overflow-x min-h-[calc(100vh-177px)]">
          <div className='xl:grid grid-cols-2 gap-1 mb-2 '>
            <div className="w-auto p-6 m-4 bg-gray-100 rounded-md shadow-md">
                <h1 className="text-3xl font-semibold text-left text-zinc-900">{t('Ui.R67.KARTA_SKOLIACEJ_FIRMY')}</h1>
                {formType=="edit" && <label className="block text-md font-semibold text-gray-800">Por.č.: {formik.values.id}</label>}
                      <div>
                        <label
                            htmlFor="name"
                            className="block text-md font-semibold text-gray-800"
                        >{t('Common.CompanyNameUpper')}</label>
                        <input
                            name='name'
                            type="text"
                            onChange={formik.handleChange} value={formik.values.name}
                            className="block w-full  px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                        />
                        </div>
                        <div>
                        <label
                            htmlFor="tel_number"
                            className="block text-md font-semibold text-gray-800"
                        >{t('Common.PhoneNumber')}</label>
                        <input
                            name='tel_number'
                            type="text"
                            onChange={formik.handleChange} value={formik.values.tel_number}
                            className="block w-full px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                        />
                        </div>
                    
                      <div>
                        <label
                            htmlFor="email"
                            className="block text-md font-semibold text-gray-800"
                        >
                            E-MAIL
                        </label>
                        <input
                            name='email'
                            type="text"
                            onChange={formik.handleChange} value={formik.values.email}
                            className="block w-full  px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                        />
                        </div>
                        <div>
                        <label
                            htmlFor="contact_person"
                            className="block text-md font-semibold text-gray-800 mt-2"
                        >{t('Common.ContactPersonUpper')}</label>
                        <input
                            name='contact_person'
                            type="text"
                            onChange={formik.handleChange} value={formik.values.contact_person}
                            className="block w-full  px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                        />
                        </div>        
            </div>
            <div className="w-auto p-6 m-4 bg-gray-100 rounded-md shadow-md">
                    <div>
                        <label
                            htmlFor="address"
                            className="block text-md font-semibold text-gray-800"
                        >
                            ADRESA
                        </label>
                        <input
                            name='address'
                            type="text"
                            onChange={formik.handleChange} value={formik.values.address}
                            className="block w-full  px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                        />
                        </div>
                        <div>
                        <label
                            htmlFor="fax"
                            className="block text-md font-semibold text-gray-800"
                        >
                             FAX
                        </label>
                        <input
                            name='fax'
                            type="text"
                            onChange={formik.handleChange} value={formik.values.fax}
                            className="block w-full px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                        />
                        </div>
                        <div>
                        <label
                            htmlFor="web_address"
                            className="block text-md font-semibold text-gray-800"
                        >
                            WEB. ADRESA
                        </label>
                        <input
                            name='web_address'
                            type="text"
                            onChange={formik.handleChange} value={formik.values.web_address}
                            className="block w-full  px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                        />
                        </div>
                        <div>
                        <label
                            htmlFor="description"
                            className="block text-md font-semibold text-gray-800"
                        >{t('Common.NoteUpper')}</label>
                        <textarea
                            name='description'
                            type="text"
                            onChange={formik.handleChange} value={formik.values.description}
                            className="block w-full  px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                        >
                        </textarea>
                        </div>  
                        <button className='hidden' type='submit' ref={submitRef}></button>    
            </div>
            </div>
            </div> 
             </form>
            </div>
            </> 
            );
} 
